import { toast } from "sonner";
import MissionShell from "../MissionShell";
import { Card, Field, CheckItem } from "@/components/kit";
import { STORYBOARD, PREP_CHECKLIST } from "../content";
import { useProgress } from "../store";
import { isDone, REQUIREMENTS, filmedCount, prepCount } from "../logic";

export default function Mission5() {
  const { state, setIn, setCompleted } = useProgress();
  const m = state.m5;
  return (
    <MissionShell id={5} done={isDone(state, 5)} validate={{ missing: REQUIREMENTS[5](state), onClick: () => { setCompleted(5, true); toast.success("Mission 05 validée !"); } }}>
      <div className="space-y-8">
        <div>
          <div className="mb-4 flex items-baseline justify-between gap-3">
            <h3 className="text-xl font-medium text-ink">Mon storyboard</h3>
            <span className="text-sm text-soft" data-testid="filmed-count">{filmedCount(state)}/4 plans filmés</span>
          </div>
          <div className="grid gap-4 md:grid-cols-2">
            {STORYBOARD.map((p, i) => (
              <Card key={p.id} className="flex flex-col gap-4" data-testid={`storyboard-plan-${i + 1}`}>
                <div className="flex items-start gap-4">
                  <span className="flex aspect-[9/16] w-12 shrink-0 items-center justify-center rounded-lg border border-gold/50 bg-ivory font-display text-lg text-gold">{i + 1}</span>
                  <div>
                    <p className="font-display text-lg text-bx">{p.title}</p>
                    <p className="font-medium text-ink">{p.action}</p>
                  </div>
                </div>
                <p className="text-sm leading-relaxed text-ink/85">{p.explain}</p>
                <p className="rounded-xl bg-ivory px-3 py-2 text-sm text-soft"><span className="font-semibold text-bx-2">Exemple : </span>{p.example}</p>
                <Field label="Mes notes" value={m.notes[p.id]} onChange={(v) => setIn("m5", "notes", p.id, v)} multiline rows={2} placeholder="Ce que je filme, où, comment…" testId={`plan-${i + 1}-notes`} />
                <CheckItem checked={m.filmed[p.id]} onChange={(v) => setIn("m5", "filmed", p.id, v)} label="Plan filmé" testId={`plan-${i + 1}-filmed`} />
              </Card>
            ))}
          </div>
          <p className="mt-3 text-sm text-soft">Tu cocheras « Plan filmé » au moment du tournage : ce n'est pas nécessaire pour valider cette mission.</p>
        </div>
        <Card>
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="text-xl font-medium text-ink">Checklist de préparation</h3>
            <span className="text-sm text-soft" data-testid="prep-count">{prepCount(state)}/6</span>
          </div>
          <div className="mt-4 space-y-2.5">
            {PREP_CHECKLIST.map((it) => <CheckItem key={it.id} checked={m.checklist[it.id]} onChange={(v) => setIn("m5", "checklist", it.id, v)} label={it.label} desc={it.desc} testId={`prep-${it.id}`} />)}
          </div>
        </Card>
      </div>
    </MissionShell>
  );
}
